__turbopack_context__.v({
  "header": "styles-module__rNbnoG__header",
  "translucentHoverOverlay": "styles-module__rNbnoG__translucentHoverOverlay",
  "videoIcon": "styles-module__rNbnoG__videoIcon",
});
